<template>
  <div class="mx-1" v-if="canVerb('fattutto', 'send')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle:sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">
          {{ computedFilterTitle }}
        </span>
      </b-button-group>
      <b-button
        type="button"
        variant="secondary"
        size="sm"
        class="btn--smaller btn--transparent"
        @click="onRefreshContent()"
        title="Refresh"
      >
        <base-icon name="reload" width="20" height="20" />
        Ricarica
      </b-button>
      <b-button
        type="button"
        variant="secondary"
        class="btn--smaller btn--transparent"
        size="sm"
        @click="sendOrRetry()"
        :disabled="!table_checked_ids.length"
      >
        <base-icon name="send" width="14" />
        <b-icon icon="plus" aria-hidden="true"></b-icon>
        <base-icon name="reload" width="20" height="20" />
        Invia selezionati
      </b-button>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="transmission_status"
                label="Status"
                v-model="filter.transmission_status"
                :options="transmission_status_options"
                :taggable="true"
                :multiple="true"
              />
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="date_from"
                label="Data Consolidata dal"
                v-model="filter.date_from"
              />
              <base-datepicker
                name="date_from"
                label="Data Consolidata al"
                v-model="filter.date_to"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="least_one_to_go"
                label="Con registrazioni da trasmettere"
                v-model="filter.least_one_to_go"
                :options="fattutto_records_options"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <fattutto-transmissions-table
        @manualFetch="manualFetch"
        :fields="fields"
        :items="items"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :ref="tableRef"
        hasChecks
        :hasChecksPaginated="true"
        :onPagination="{
          action: 'confirm',
          checkCondition: hasChanges,
          title: 'Conferma salvataggio',
          message: 'Stai per cambiare pagina. Salvare le modifiche?',
          yesCallback: saveOnPageChange,
          noCallback: onCancelConfirm,
          yesLabel: 'SALVA',
          yesVariant: 'lisaweb',
          noLabel: 'ANNULLA',
        }"
        @interaction="onInteraction"
        @singleCheck="onInteraction"
        @onSendOrRetry="sendOrRetry"
        @transmissionActionsEnd="transmissionActionsEnd"
      ></fattutto-transmissions-table>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import FattuttoTransmissionsTable from "@/components/tables/FattuttoTransmissions.vue";
import FormMixin from "@/mixins/FormMixin";
import { toLocaleDate } from "@/utils/dates";
import moment from "moment";

moment.locale("it");
import { canVerb } from "@/utils/permissions";
import { mapActions, mapGetters } from "vuex";
import BaseSelect from "../../form/BaseSelect.vue";
import BaseDatepicker from "../../form/BaseDatepicker.vue";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, FormMixin, SidebarFilterMixin],
  data() {
    return {
      hasUserInteraction: false, // se l'utente seleziona/deseleziona checkbox e/o select
      isLoading: false,
      repository: "fattutto",
      resource: "config",
      tableRef: "FattuttoSendTableRef",
      current_config: {},
      activeFilters: {},
      filterName: "filterDirectDebits",
      filter: this.initFilter(),
      table_checked_ids: [],
      checkedIds: [],
      fields: [
        {
          key: "check",
          label: "",
          sortable: false,
          thClass: "check",
          thStyle: {
            width: "10px",
          },
          class: "check",
        },
        {
          key: "actions",
          label: "",
          thClass: "align-middle",
          thStyle: {
            width: "40px",
            //width: `${20 * this.actions.length}px`,
          },
          tdClass: "actions",
        },
        {
          key: "consolidated_at",
          label: this.getDictionary("consolidated_at", "fattutto"),
          formatter: (value) => toLocaleDate(value, "DD/MM/YYYY"),
        },
        // {
        //   key: "fattutto_transmission.id",
        //   label: this.getDictionary("fattutto_transmission_id", "fattutto"),
        //   formatter: (value) => value ?? "-",
        // },
        {
          key: "fattutto_transmission.transmission_status",
          label: this.getDictionary("transmission_status", "fattutto"),
          formatter: (value) =>
            value != null ? this.transmission_status[value] : "-",
        },
        {
          key: "fattutto_transmission.created_at",
          label: this.getDictionary("created_at", "fattutto"),
          formatter: (value) =>
            value ? toLocaleDate(value, "DD/MM/YYYY HH:mm:ss") : "-",
        },
        {
          key: "fattutto_transmission.updated_at",
          label: this.getDictionary("updated_at", "fattutto"),
          formatter: (value) =>
            value ? toLocaleDate(value, "DD/MM/YYYY HH:mm:ss") : "-",
        },
        {
          key: "fattutto_transmission.progress_percentage",
          label: this.getDictionary("progress_percentage", "fattutto"),
          formatter: (value) => `${value ? `${value}%` : "-"}`,
        },
        {
          key: "fattutto_transmission.record",
          label: this.getDictionary("records", "fattutto"),
        },
        {
          key: "fattutto_transmission.errors",
          label: this.getDictionary("errors", "fattutto"),
          formatter: (value) => (value != null ? value.length : "-"),
        },
      ],
      items: [],
      transmission_status: {
        "-1": "Errore",
        0: "Creato",
        1: "Pronto per la trasmissione",
        2: "In corso",
        3: "Completato",
        4: "Completato con errori",
        5: "In coda",
        6: "Caricamento dati",
      },
      transmission_status_options: [
        { value: -1, text: "Errore" },
        { value: 0, text: "Creato" },
        { value: 1, text: "Pronto per la trasmissione" },
        { value: 2, text: "In corso" },
        { value: 3, text: "Completato" },
        { value: 4, text: "Completato con errori" },
        { value: 5, text: "In coda" },
        { value: 6, text: "Caricamento dati" },
      ],
      fattutto_records_options: [
        { value: 0, text: "No" },
        { value: 1, text: "Si" },
      ],
    };
  },
  components: {
    BaseIcon,
    BaseDatepicker,
    BaseSelect,
    FattuttoTransmissionsTable,
  },
  methods: {
    canVerb,
    toLocaleDate,
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.table_checked_ids = [];
      this.checkedIds = [];
      this.hasUserInteraction = false;
      this.open_filter = true;
    },
    endSendOrRetry() {
      this.hasUserInteraction = false;
      this.$refs[this.tableRef].fetch(this.current_config);
    },
    onSendOrRetry() {
      this.selectedRows = [];
      this.checkedIds = [];
      this.checkAll = false;
      this.$emit("onSendOrRetry");
      /* emit these
       * this.hasUserInteraction = false;
       * this.$refs[this.tableRef].fetch(this.current_config);
       */
    },
    sendOrRetry() {
      // this.isLoading = true;
      this.$refs[this.tableRef].isLoading = true;
      console.log("this.table_checked_ids", this.table_checked_ids);
      if (!this.table_checked_ids.length) {
        this.endSendOrRetry();
        return;
      }
      /* Make all the Promises and send them all */
      let promises = [];
      this.table_checked_ids.forEach((el) => {
        promises.push(this.sendOrRetryPromise(el));
      });
      Promise.all(promises)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: "Trasmissioni inviate",
          });
          this.endSendOrRetry();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          // this.isLoading = false;
          this.$refs[this.tableRef].isLoading = false;
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },
    checkIsChecked(item) {
      // const evl = this.checkedIds.indexOf(item.consolidated_at) >= 0;
      const evl = this.checkedIds.some(
        (el) => el.consolidated_at === item.consolidated_at,
      );
      item.check = evl;
      return evl;
    },
    checkedEl(event, index, item) {
      console.log("clicked :", index);
      if (!this.hasChecksPaginated) return;
      // if (event && this.checkedIds.indexOf(item.consolidated_at) === -1) {
      const i = this.checkedIds.findIndex(
        (el) => el.consolidated_at === item.consolidated_at,
      );
      if (event && i === -1) {
        // this.checkedIds.push(item.consolidated_at);
        this.checkedIds.push(item);
      } else {
        // const i = this.checkedIds.indexOf(item.consolidated_at);
        // const i = this.checkedIds.findIndex(
        //   (el) => el.consolidated_at === item.consolidated_at
        // );
        if (i > -1) {
          this.checkedIds.splice(i, 1);
        }
      }
      this.$emit("singleCheck", this.checkedIds);
    },
    sendOrRetryPromise(item) {
      const payload = {
        date: item.consolidated_at,
      };
      const Repo = RepositoryFactory.get(this.repository);
      const action = this.checkSendOrRetry(item);
      if (!action) {
        return Promise.reject(
          new Error(
            "Operazione non disponibile per lo stato della trasmissione",
          ),
        );
      }
      return (
        action === "send"
          ? Repo.send_transmission(payload)
          : Repo.retry_transmission(item.fattutto_transmission.id)
      )
        .then(() => {})
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          // this.isLoading = false;
          this.$refs[this.tableRef].isLoading = false;
          throw error;
        });
    },
    checkSendOrRetry(f) {
      let action;
      const transmission = f?.fattutto_transmission;
      if (
        !transmission ||
        !Object.prototype.hasOwnProperty.call(
          transmission,
          "transmission_status",
        )
      ) {
        action = "send";
      } else if (
        Object.keys(transmission).length &&
        [3, 4].includes(transmission.transmission_status)
      ) {
        action = "retry";
      }
      if (!action) {
        this.$showSnackbar({
          preset: "error",
          text: `Siamo spiacenti, c'è stato un errore. Si prega di riprovare più tardi.`,
        });
        return;
      }
      return action;
    },
    onInteraction(checkedIds) {
      console.log("checkedIds", checkedIds);
      this.table_checked_ids = checkedIds;
      this.hasUserInteraction = checkedIds.length ? true : false;
    },
    saveOnPageChange() {
      this.sendOrRetry();
    },
    onCancelConfirm() {
      // this.$showSnackbar({
      //   preset: "info",
      //   text: `Trasmissione annullata`,
      // });
      // this.hasUserInteraction = false;
      return false;
    },
    initFilter() {
      let init = {
        date_from: null,
        date_to: null,
        transmission_status: null,
        least_one_to_go: null,
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // if (
      //   typeof this.filter?.byAttribute?.setup_at !== "undefined" &&
      //   this.filter?.byAttribute?.setup_at !== null
      // ) {
      //   const setup_at_moment = moment(this.filter.byAttribute.setup_at).format(
      //     "YYYY-MM",
      //   );
      //   this.setupAtMoment = this.filter.byAttribute.setup_at;
      //   this.filter.byAttribute.setup_at = setup_at_moment;
      // }
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch(this.current_config);
      // this.$refs[this.tableRef].fetch().then(() => {
      //   if (Object.keys(this.setupAtMoment).length)
      //     this.filter.byAttribute.setup_at = this.setupAtMoment;
      // });
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getBankAccounts: "bank_accounts",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    transmissionActionsEnd() {
      this.onRefreshContent();
    },
    onRefreshContent() {
      // let criteria = this.filter;
      // this.saveFilterByName({ name, criteria });
      this.$refs[this.tableRef].fetch(this.current_config);
    },
  },
  created() {
    const Repo = RepositoryFactory.get("fattutto");
    this.isLoading = true;
    Repo.index_transmission()
      .then((response) => {
        console.log("response", response);
        this.items = response?.data?.data ?? [];
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  computed: {
    hasChanges() {
      return this.hasUserInteraction;
    },
    rep() {
      return this.repository;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  mounted() {
    this.current_config.verb = {
      name: "transmissions",
      canVerb: this.canVerb("fattutto", "send"),
    };
    this.$refs[this.tableRef].fetch(this.current_config);
  },
};
</script>
